module.exports = __webpack_public_path__ + "img/ug.56b2c3c0.svg";